const localstorageKeySet = {
  ECOYA_ID: "ecoya_id",
  SUBSCRIPTION_IDS: "subscription_ids",
  FREE_CODE_IDS: "free_code_ids",
  IS_SESSION_TIME_OUT: "is_Session_Time_out",
  CREDIT_PAYMENT_FAIL_CALL_OUT_CLOSE: "credit_payment_fail_call_out_close",
};

export { localstorageKeySet };
